import * as React from 'react'
import { Grid } from '@mui/material'

import BITableContent from './Table'
import BIChartContent from './Chart'
import { useSubmitBIFilters } from './@hooks'
import BIUrlModal from 'Pages/BusinessLogistics/BI/Page/UrlModal'
import BI3DTable from './3DTable'
import { isLoadingCommonFilters } from '@signals'
import { AppResultsSkeleton } from '@components'
import { BIHeaders, BIIsLoadingTable, BISelectedOfficeOptions, BITableData } from './@signals'


export default function BIPageContent() {

	useSubmitBIFilters()
	// The tables only show their own skeleton over earlier results; the first search needs this one.
	const hasResults = !!BITableData.value.rowValues?.length || !!BISelectedOfficeOptions.value?.length || !!BIHeaders.value?.length
	const isFirstLoad = (BIIsLoadingTable.value || isLoadingCommonFilters.value) && !hasResults

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			{isFirstLoad && <AppResultsSkeleton/>}
			<BI3DTable />
			<BITableContent/>
		</Grid>
		<Grid item xs={12}>
			<BIChartContent/>
		</Grid>
		<Grid item xs={12}>
			<BIUrlModal/>
		</Grid>
	</Grid>
}